import {h, Fragment} from "preact"
import { defaultConfig } from '../config';
import { useAppState, HistoryElement, useResponse } from '@nosto/preact';

export default function History() {
  const { historyItems } = useAppState();
  const { products } = useResponse();

  if (!historyItems || !historyItems.length) {
    return;
  }

//noste ->   Added this, so the History is hidden while input is on focus mode 
  if (!products?.hits?.length && !keywords?.hits?.length) {
    return;
  }

  return (
    <>
      {historyItems?.slice(0, defaultConfig.historySize).map((item) => (
        <HistoryElement query={{ query: item }}>
          <li class="ns-text-uppercase ns-clickable">{item}</li>
        </HistoryElement>
      ))}
    </>
  );
}
